<template>
  <div class="wizard-container-acu">
    <ag-grid-vue ref="agGridTablee"
      class=" acu-wizard-table ag-theme-material w-100 my-4 ag-grid-table ap_ag_grid acu_dashboard_tbl"
      :defaultColDef="defaultColDef" :rowData="items" colResizeDefault="shift" domLayout="autoHeight"
      @grid-ready="onGridReady" :enableRtl="$vs.rtl" @cell-clicked="onCellClicked" :suppressDragLeaveHidesColumns="true"
      :suppressAggFuncInHeader="true" :suppressPaginationPanel="true" :suppressRowClickSelection="true"
      :pagination="true" :animateRows="true" :columnDefs="modifiedHeaders">
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import CellRendererAcuStatus from "../../renderer/CellRendererAcuStatus";
import CellRendererCloudStatus from "../../renderer/CellRendererCloudStatus";
import CellRendererStatus from "../../renderer/CellRendererStatus";
import CellRendererSynchStatus from "../../renderer/CellRendererSynchStatus.vue";
import CellRendererAcuSlot from "../../renderer/CellRendererAcuSlot.vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";


export default {
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    selectAcu: {
      type: Function,
      default: (e) => { },
    },
  },
  computed: {
    modifiedHeaders() {
      return this.headers.map((header) => ({
        ...header,
        cellClassRules: {
          "selected-cell": (params) =>
            this.selectedCell &&
            this.selectedCell.rowIndex === params.node.rowIndex &&
            this.selectedCell.field === params.colDef.field,
        },
      }));
    },
  },
  components: {
    AgGridVue,
    CellRendererAcuStatus,
    CellRendererCloudStatus,
    CellRendererStatus,
    CellRendererSynchStatus,
    CellRendererAcuSlot
  },
  data() {
    return {
      selectedCell: null,
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        lockPinned: true,
      },
      components: {
        CellRendererCloudStatus,
        CellRendererStatus,
      },
      opacity_table: false,
    };
  },

  methods: {


    onCellClicked(cell) {
      this.$emit("selectAcu", cell.data);
      this.selectedCell = {
        rowIndex: cell.rowIndex,
        column: cell.colDef.field,
      };
      return true;

    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.autoSizeAll();
    },
    handleWindowResize() {
      this.autoSizeAll();
    },
    autoSizeAll() {
      this.gridApi.sizeColumnsToFit();
      this.$vs.loading.close();
      this.opacity_table = true;
    },
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
    this.$root.$on("refreshAcApTable", () => {
      this.opacity_table = false;
      this.autoSizeAll();
      this.$vs.loading.close();
    });
  },
};
</script>

<style lang="scss">
.wizard-container-acu {
  min-height: 650px;
  box-sizing: border-box;
  overflow: hidden;
  margin-right: 10px;
  padding: 20px;
}

.acu-wizard-table {
  .ag-row-focus {
    background-color: #4f4ba2;
    color: white !important;
  }
}
</style>